<template>
  <div class="library-header">
    <h3 class="">Documents</h3>
    <v-divider light></v-divider>
    <div class="d-flex flex-row align-center">
      <CSelect v-model="selectedSort" :changeFunction="setSort" :options="sort" :itemValue="'value'" :itemText="'text'"
        style="width: 20% !important"></CSelect>

      <CInput @input="searchWithDebounce" v-model="query" placeholder="Search for document" :type="'text'" :iconSrc="magniIcon"
         style="flex: 1 1 auto;" class="mx-2"></CInput>
      <div class="p-1 rounded-lg mx-2" :class="[cardView ? 'bg-primary' : 'border']">
        <v-icon class="" :color="cardView ? 'white' : 'grey'" @click="activateCard">mdi-view-grid</v-icon>
      </div>
      <div class="p-1 rounded-lg" :class="[!cardView ? 'bg-primary' : 'border']">
        <v-icon  :color="!cardView ? 'white' : 'grey'"
          @click="activateList">mdi-format-list-checkbox</v-icon>
      </div>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import magniIcon from '../../../assets/images/icons/c_magnifier.svg'
import CSelect from '../c-select.vue'
import CInput from '../c-input.vue'
export default {
  components: { CSelect, CInput },
  mounted() {
  },
  data() {
    return {
      magniIcon: magniIcon,
      sort: [{ text: 'Latest', value: 'latest' }, { text: 'Oldest', value: 'oldest' }, { text: 'Ascending', value: 'title_asc' }, { text: 'Descending', value: 'title_desc' }],
      selectedSort: this.$store.state.sort,
    }
  },
  computed: {
    cardView() {
      return this.$store.state.cardView
    },
    org_id() {
      return this.$store.state.organization.id
    },
    query: {
      get: function () {
        return this.$store.state.query
      },
      set: function (newValue) {
        this.$store.commit('changeQuery', newValue)
      }
    },
    page: {
      get: function () {
        return this.$store.state.page
      },
      set: function (newValue) {
        this.$store.commit('changePage', newValue)
      }
    },
    sort() {
      return this.$store.state.sort
    },
    sortLabel() {
      if (!this.sort) {
        return "Sort By"
      } else if (this.sort === 'name_asc') {
        return "Name Asc."
      } else if (this.sort === 'name_desc') {
        return "Name Desc."
      } else return this.sort
    }
  },
  methods: {
    setSort() {
      this.$store.commit('changeSort', this.selectedSort)
      this.$store.dispatch('getDocuments')
    },
    activateCard() {
      this.$store.commit('changeView', true)
    },
    activateList() {
      this.$store.commit('changeView', false)
    },
    sortDocuments(sort) {
      this.page = 1
      this.$store.commit('changeSort', sort)
      this.$store.dispatch('getDocuments')
    },
    searchDocuments() {
      this.page = 1
      this.$store.dispatch('getDocuments')
    },
    searchWithDebounce: _.debounce(function (e) {
      this.searchDocuments()
    }, 500),
    clearSearch() {
      this.query = ""
      this.page = 1
      this.$store.dispatch('getDocuments')
    }
  }
}
</script>

<style lang="scss">
.hover {
  &:hover {
    cursor: pointer;
  }
}
</style>
